APP.Template = (/** @lends APP.Template */function () {
	'use strict';

	var tpl = {};

	function init() {
		APP.Performance.getCachedDOM().$body.find('[data-tpl]').each(function () {
			var $this = $(this),
				id = $this.attr('data-tpl');

			tpl[id] = Handlebars.compile($this.html());

			if (id.indexOf('partial/') === 0) {
				Handlebars.registerPartial(id.split('/')[1], $this.html());
			}

		});

		initHelpers();
	}

	function initHelpers(){
		Handlebars.registerHelper('eq', function (v1, v2, options) {
			if (v1 === v2) {
				return options.fn(this);
			}
			return options.inverse(this);
		});
	}

	function get(id) {
		return tpl[id];
	}

	return {
		init: init,
		get: get
	};

}());

